export default "__VITE_ASSET__Bv3ov0nO__"